import { FC } from "react";
import { Outlet } from "react-router-dom";
import { AccessPageProvider } from "../../providers/Access/AccessPage/AccessPageProvider";
import { AccessProfileProvider } from "../../providers/Access/AccessProfile/AccessProfileProvider";

interface Props {
  element?: any;
  path?: string;
}

export const AccessRoute: FC<Props> = () => {
  return (
    <AccessPageProvider>
      <AccessProfileProvider>
        <Outlet />
      </AccessProfileProvider>
    </AccessPageProvider>
  );
};
